<script>
export default {
  name: "BorrowerViewDto",

  props: {
    type: Object,
    booking: {},
    required: true,
    type: String,
    cardUserId: {},
    required: true,
    type: Boolean,
    borrowerView: {},
    required: true,
  },

  data() {
    return {
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      totalRentalFee: 0,
    };
  },

  components: {
    LinkPay: () => import("@/components/LinkPay.vue"),
    PaystackButton: () => import("@/components/payments/paystackButton.vue"),
  },

  computed: {
    verified() {
      if (
        this.$store.getters.user.stitch_verification_received ||
        this.$store.getters.user.manual_verification_received ||
        this.$store.getters.user.verified
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  mounted() {
    console.log(
      "mounted",
      Number(this.booking.rentalFee),
      Number(this.booking.deliveryFee),
      Number(this.booking.serviceFee),
      this.booking.totalServiceFee,
      this.booking.subTotal
    );

    if (
      this.booking.deliveryFee !== 0 &&
      this.booking.deliveryFee !== "0" &&
      this.booking.deliveryFee !== "" &&
      this.booking.deliveryFee !== null
    ) {
      this.totalRentalFee = (
        Number(this.booking.rentalFee) +
        Number(this.booking.deliveryFee) +
        Number(this.booking.totalServiceFee)
      ).toFixed(0);
    } else {
      this.totalRentalFee = (
        Number(this.booking.rentalFee) + Number(this.booking.totalServiceFee)
      ).toFixed(0);
    }

    // this.totalRentalFee = (
    //   Number(this.booking.rentalFee) +
    //   Number(this.booking.deliveryFee) +
    //   Number(this.booking.totalServiceFee)
    // ).toFixed(0);

    console.log(this.totalRentalFee);
  },

  methods: {
    toverify() {
      this.$router.push({
        name: `Verify 📊`,
        params: { booking: this.booking },
      });
    },
    paySuccess() {
      console.log("hello wtf PAY SUCCESS");
      this.$emit("paySuccess");
    },
  },
};
</script>

<template>
  <div>
    <div class="mx-6 mt-md-8 my-auto text-body-1">
      <v-row>
        <div class="text-center text-h5 my-4 mb-8">Payment Info</div>
        <v-spacer />
        <div
          class="hidden-sm-and-down"
          v-if="booking.status === 'awaiting-payment'"
        >
          <paystack-button
            v-if="verified === true"
            @paySuccess="paySuccess()"
            :booking="booking"
          ></paystack-button>

          <v-btn
            v-if="verified === false"
            @click="toverify()"
            elevation="6"
            large
            block
            color="accent"
            class="ml-n3 appbutton ma-1 text-body-1 rounded-lg white--text font-weight-medium"
            z-index="12"
          >
            <base-img
              :src="require('@/assets/logos/icon1.svg')"
              contain
              max-height="35"
              max-width="35"
              class="mr-2"
            />
            Verify and Pay
          </v-btn>
        </div>
        <!-- <link-pay
          v-if="
            booking.status === 'awaiting-payment' &&
            this.$route.name !== 'Return'
          "
          class="hidden-sm-and-down"
          :booking="booking"
          @showError="errorDialog = true"
        ></link-pay> -->
      </v-row>
      <v-row class="pa-2">
        <p label="Date range" class="black--text font-weight-bold" readonly>
          {{ booking.dateRange }} days
        </p>
        <v-spacer></v-spacer>
        <p label="Date range" class="black--text font-weight-bold">
          {{ booking.startDate }} - {{ booking.endDate }}
        </p>
      </v-row>
      <v-divider class="my-4"></v-divider>
      <v-row class="pa-2">
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-top="80"
          :nudge-left="350"
          transition="scale-transition"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <p
              label="Daily Fee"
              class="black--text text-body-2 text-decoration-underline"
              v-bind="attrs"
              v-on="on"
              prepend="R"
              readonly
            >
              <span v-if="booking.dailyFee"> {{ booking.dailyFee }}</span>
              <span v-else-if="!booking.dailyFee"> DailyFee</span> x
              {{ booking.dateRange }} days
            </p>
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="black"
              class="mb-4 ml-1 text-decoration-none"
              small
              >mdi-information</v-icon
            >
          </template>
          <v-card class="tooltip" style="border-radius: 12px" elevation="12">
            <v-card-actions
              ><v-btn @click="menu1 = false" class="mt-n3" icon
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-card-text
                class="text-body-2"
                style="color: rgb(113, 113, 113) !important"
              >
                Average daily rate is rounded.
              </v-card-text></v-card-actions
            >
          </v-card>
        </v-menu>

        <v-spacer></v-spacer>

        <p
          label="Total Fee"
          class="black--text text-body-2 font-weight-medium"
          prepend="R"
          readonly
        >
          <span v-if="booking.dailyEffectiveRate && booking.discount"
            >R {{ booking.dailyEffectiveRate }}</span
          >
          <span v-else>R {{ booking.rentalFee }}</span>
        </p>
      </v-row>

      <v-row class="pa-2" v-if="booking.discount">
        <v-menu
          v-if="booking.dateRange >= 28"
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-top="120"
          :nudge-left="350"
          transition="scale-transition"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <p
              label="Daily Fee"
              class="black--text text-body-2 text-decoration-underline"
              v-bind="attrs"
              v-on="on"
              prepend="R"
              readonly
            >
              <span>Monthly</span>

              price discount
            </p>
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="black"
              class="mb-4 ml-1 text-decoration-none"
              small
              >mdi-information</v-icon
            >
          </template>
          <v-card class="tooltip" style="border-radius: 12px" elevation="12">
            <v-card-actions
              ><v-btn @click="menu2 = false" class="mt-n8" icon
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-card-text
                class="text-body-2"
                style="color: rgb(113, 113, 113) !important"
              >
                {{ booking.lenderName }}’s rental has monthly discounts for
                rentals longer than 7 days.
              </v-card-text></v-card-actions
            >
          </v-card>
        </v-menu>

        <v-menu
          v-else
          v-model="menu3"
          :close-on-content-click="false"
          :nudge-top="80"
          :nudge-left="350"
          transition="scale-transition"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <p
              label="Daily Fee"
              class="black--text text-body-2 text-decoration-underline"
              v-bind="attrs"
              v-on="on"
              prepend="R"
              readonly
            >
              <span>Weekly</span>

              price discount
            </p>
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="black"
              class="mb-4 ml-1 text-decoration-none"
              small
              >mdi-information</v-icon
            >
          </template>
          <v-card class="tooltip" style="border-radius: 12px" elevation="12">
            <v-card-actions
              ><v-btn @click="menu3 = false" class="mt-n4" icon
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-card-text
                class="text-body-2"
                style="color: rgb(113, 113, 113) !important"
              >
                {{ booking.lenderName }}’s rental has weekly discounts for
                rentals longer than 7 days.
              </v-card-text></v-card-actions
            >
          </v-card>
        </v-menu>

        <v-spacer></v-spacer>

        <p
          label="Total Fee"
          class="green--text text-body-2 font-weight-medium"
          prepend="R"
          readonly
        >
          -R {{ booking.discount }}
        </p>
      </v-row>

      <v-row v-if="booking.deliveryFee != 0" class="pa-2">
        <v-menu
          v-model="menu4"
          :close-on-content-click="false"
          :nudge-top="120"
          :nudge-left="350"
          transition="scale-transition"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <p
              label="Delivery Fee text"
              class="black--text text-body-2 text-decoration-underline"
              readonly
              v-bind="attrs"
              v-on="on"
            >
              Delivery Fee
            </p>
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="black"
              class="mb-4 ml-1 text-decoration-none"
              small
              >mdi-information</v-icon
            >
          </template>
          <v-card class="tooltip" style="border-radius: 12px" elevation="12">
            <v-card-actions
              ><v-btn @click="menu4 = false" class="mt-n8" icon
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-card-text
                class="text-body-2"
                style="color: rgb(113, 113, 113) !important"
              >
                This is the fee for delivery. If it is 0 that means the borrower
                is expected to collect the item.
              </v-card-text></v-card-actions
            >
          </v-card>
        </v-menu>

        <v-spacer></v-spacer>

        <p
          label="Delivery Fee Amount"
          class="black--text text-body-2 font-weight-medium"
          readonly
        >
          R {{ booking.deliveryFee }}
        </p>
      </v-row>

      <v-row class="pa-2">
        <v-menu
          v-model="menu5"
          :close-on-content-click="false"
          :nudge-top="120"
          :nudge-left="350"
          transition="scale-transition"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <p
              label="Service Fee text"
              class="black--text text-body-2 text-decoration-underline"
              readonly
              v-bind="attrs"
              v-on="on"
            >
              Service Fee
            </p>
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="black"
              class="mb-4 ml-1 text-decoration-none"
              small
              >mdi-information</v-icon
            >
          </template>
          <v-card class="tooltip" style="border-radius: 12px" elevation="12">
            <v-card-actions
              ><v-btn @click="menu5 = false" class="mt-n8" icon
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-card-text
                class="text-body-2"
                style="color: rgb(113, 113, 113) !important"
              >
                The service fee, helps us run platform and offer services such
                as 24/7 support and ensuring the safety of your rentals and
                transactions.
              </v-card-text></v-card-actions
            >
          </v-card>
        </v-menu>

        <v-spacer></v-spacer>

        <p
          v-if="booking.totalServiceFee"
          label="Service Fee Amount"
          class="black--text text-body-2 font-weight-light"
          prepend="R"
          readonly
        >
          R {{ booking.totalServiceFee }}
        </p>
        <p
          v-else-if="booking.serviceFee"
          label="Service Fee Amount"
          class="black--text text-body-2 font-weight-light"
          prepend="R"
          readonly
        >
          R {{ booking.serviceFee }}
        </p>
      </v-row>
      <v-divider class="my-6"></v-divider>

      <v-row class="pa-2">
        <v-menu
          v-model="menu7"
          :close-on-content-click="false"
          :nudge-top="120"
          :nudge-left="350"
          transition="scale-transition"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <p
              label="Service Fee text"
              class="black--text text-body-2 text-decoration-underline"
              readonly
              v-bind="attrs"
              v-on="on"
            >
              Total Rental Fee
            </p>
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="black"
              class="mb-4 ml-1 text-decoration-none"
              small
              >mdi-information</v-icon
            >
          </template>
          <v-card class="tooltip" style="border-radius: 12px" elevation="12">
            <v-card-actions
              ><v-btn @click="menu6 = false" class="mt-n8" icon
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-card-text
                class="text-body-2"
                style="color: rgb(113, 113, 113) !important"
              >
                Refunded after 24 hours upon return, subject to quality check by
                owner.
              </v-card-text></v-card-actions
            >
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>

        <!-- <p
          v-if="this.booking.subTotal"
          label="Service Fee Amount"
          class="black--text text-body-2 font-weight-medium"
          prepend="R"
          readonly
        >
          R {{ this.booking.subTotal }}
        </p> -->

        <p
          label="Service Fee Amount"
          class="black--text text-body-2 font-weight-medium"
          prepend="R"
          readonly
        >
          R {{ this.totalRentalFee }}
        </p>
      </v-row>

      <v-divider class="my-6" v-if="booking.deposit != ''"></v-divider>

      <v-row class="pa-2" v-if="booking.deposit != ''">
        <v-menu
          v-model="menu6"
          :close-on-content-click="false"
          :nudge-top="120"
          :nudge-left="350"
          transition="scale-transition"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <p
              class="black--text text-body-2 text-decoration-underline"
              readonly
              v-bind="attrs"
              v-on="on"
            >
              Refundable Deposit
            </p>
            <v-icon
              v-bind="attrs"
              v-on="on"
              color="black"
              class="mb-4 ml-1 text-decoration-none"
              small
              >mdi-information</v-icon
            >
          </template>
          <v-card class="tooltip" style="border-radius: 12px" elevation="12">
            <v-card-actions
              ><v-btn @click="menu6 = false" class="mt-n8" icon
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <v-card-text
                class="text-body-2"
                style="color: rgb(113, 113, 113) !important"
              >
                Refunded after 24 hours upon return, subject to quality check by
                owner.
              </v-card-text></v-card-actions
            >
          </v-card>
        </v-menu>

        <v-spacer></v-spacer>

        <p
          label="Service Fee Amount"
          class="black--text text-body-2 font-weight-medium"
          prepend="R"
          readonly
        >
          R {{ booking.deposit }}
        </p></v-row
      >
      <v-divider class="my-6"></v-divider>
      <v-row class="pa-2" style="padding-bottom: 0px !important">
        <p label="Total text" class="black--text" readonly>
          <b>Total </b>
        </p>

        <v-spacer></v-spacer>

        <p label="Grand Total" class="black--text" prepend="R" readonly>
          <b> R {{ booking.total }} </b>
        </p>
      </v-row>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
